import {Injectable} from '@angular/core';
import {ProductListing} from 'src/app/raintree/interface/product-listing/product-listing';
import {NormalFilterItem} from '../interface/normal-filter-item';
import {SingleFilterControl} from '../interface/single-filter-control';
import {SegmentCategoryControl} from "../interface/segment-category-control";
import {SubCategoryControls} from "../interface/sub-category-controls";

@Injectable({
	providedIn: 'root'
})
export class FabricFilterResultService {

	constructor() {
	}

	public getFilteredResultForCommonFilter(
		products: ProductListing[],
		items: NormalFilterItem[],
		key: string
	): ProductListing[] {

		let activatedFilters: string[] = [];
		let result: ProductListing[] = [...products];

		activatedFilters = items.filter(item => item.activated).map(item => item.name);

		if (activatedFilters.length > 0) {
			result = result.filter((preview: ProductListing) => {
				return Array.isArray(preview.product[key]) &&
					this._isAnyItemCommon(preview.product[key].map((p: any) => p.name), activatedFilters);
			});
		}

		return result;
	}

	public getFilteredResultForCommonFilterForCategory(
		products: ProductListing[],
		items: NormalFilterItem[],
		key: string): ProductListing[] {

		let activatedFilters: string[] = [];
		let result: ProductListing[] = [...products];

		activatedFilters = items.filter(
			(item: NormalFilterItem) => item.activated).map(
				(item: NormalFilterItem) => item.name);

		if (activatedFilters.length > 0) {

			result = result.filter((preview: ProductListing) => {
				return activatedFilters.includes(preview.product[key].name);
			});
		}
		return result;
	}


	public filterResultForNestedFilter(
		products: ProductListing[],
		items: SegmentCategoryControl[],
		key: string): ProductListing[] {

		let activatedFilters: string[] = [];
		let result: ProductListing[] = [...products];

		items.forEach((item: SegmentCategoryControl): void => {

			item.options.forEach((option: SubCategoryControls): void => {
				if (option.activated) activatedFilters.push(option.name)
			});
		});

		if (activatedFilters.length > 0) {
			result = result.filter((preview: ProductListing) => {
				return activatedFilters.includes(preview.product[key].name);
			});
		}
		return result;
	}

	public getFilteredResultByRange(
		products: ProductListing[],
		key: string,
		min: number,
		max: number,
		product: boolean = true
	): ProductListing[] {

		if (product) {
			if (key != 'gsm') {
				return products.filter((item: ProductListing) => item.product[key] >= min && item.product[key] <= max);
			} else {
				return products.filter((item :ProductListing) => item[key] >= min && item[key] <= max);
			}
		}

		return products.filter((item: ProductListing) => item[key] >= min && item[key] <= max);
	}

	public getSingleFilteredResult(
		products: ProductListing[],
		control: SingleFilterControl
	): ProductListing[] {

		let productsList: ProductListing[] = [];

		products.forEach((elm:ProductListing): void => {
			if (control.options) {


				let madeToOrderFabricQuantity: number = elm.product.madeToOrderFabric ? elm.product.madeToOrderFabric?.totalQuantity : 0;

				// if (elm.product.quantity > 0) //Previous condition

				if (elm.product.totalQuantity > 0 || madeToOrderFabricQuantity > 0) {
					productsList.push(elm)
				}
			} else {
				productsList.push(elm)

			}

		});
		return productsList
	}

	private _isAnyItemCommon(arr1: string[], arr2: string[]): boolean {
		return arr1.some((item: string) => arr2.includes(item));
	}
}
